<section class="service-page">
  <div class="row pad">
    <div class="service-page__inner">
      <div class="text-muted">1st November 2025</div>

      <h1>Cookie Policy</h1>

      <p>
        AE EventsCo Holdings LLC ("we", "us", "our") is committed to protecting
        and respecting your privacy as described in our Privacy Policy, of which
        this Cookie Policy forms a part. The Cookie Policy provides you with
        information about how we use cookies when you visit or communicate with
        us through our websites. This Cookie Policy does not apply to, and we
        are not responsible for, the privacy practices of third-party websites
        which may be linked to this website.
      </p>

      <h2>Cookies and other Web-based Tracking Technologies</h2>

      <p>
        We (or our service providers) may use different technologies such as
        cookies, web beacons, pixels, or other types of small files or web-based
        tracking technologies to gather certain information. Cookies are small
        pieces of text. They are provided by most websites and stored by your
        web browser on the computer, phone, or other device that you are using.
        Cookies allow the website to “remember” your actions or preferences over
        time. Web beacons and pixel tags are electronic images that may be used
        on our sites or in our emails. We use web beacons, for example, to
        deliver cookies, count visits, understand usage of our sites, analyze
        the effectiveness of site features and campaigns, and tell if an email
        has been opened and acted upon.
      </p>

      <h2>Types of cookies</h2>

      <p>
        A cookie can be classified by its lifespan and the domain to which it
        belongs. As to lifespan, a cookie is either:
      </p>

      <ul>
        <li>
          a session cookie, which is erased when the user closes the browser,
          orengaging with our online services
        </li>
        <li>
          a persistent cookie, which remains on the user’s computer/device for a
          period of time determined by the party that set the cookie
        </li>
      </ul>

      <p>As for the domain to which a cookie belongs, a cookie may be:</p>

      <ul>
        <li>
          a first-party cookie, which is set by the web server of the web page
          the user is visiting, or
        </li>
        <li>
          a third-party cookie, which is set by a different domain (this can
          happen when a web page references a file located outside its domain)
        </li>
      </ul>

      <p>
        Cookies and similar technologies do not require your consent to this
        policy when they are strictly necessary to provide services to you—for
        example, when a cookie is used to provide required data protection to
        secure our website, or to keep track of your selections or input, such
        as a form you are filling out, or language preference.
      </p>

      <h2>Types of cookies we use</h2>

      <h3>Strictly Necessary:</h3>

      <p>
        These cookies are necessary for the website to function and cannot be
        switched off in our systems. They are usually only set in response to
        actions made by you which amount to a request for services, such as
        setting your privacy preferences, logging in or filling in forms. You
        can set your browser to block or alert you about these cookies, but some
        parts of the site will not then work.
      </p>

      <h3>Analytics and Performance:</h3>

      <p>
        We make use of analytic cookies to analyze how our visitors use our
        website and to monitor website performance. This allows us to provide a
        high-quality experience by customizing our offering and quickly
        identifying and fixing any issues that arise. For example, we might use
        performance cookies to keep track of which pages are most popular, which
        method of linking between pages is most effective, and to determine why
        some pages are receiving error messages. We might also use these cookies
        to highlight site services that we think will be of interest to you
        based on your usage of the Website.
      </p>

      <h3>Website Functionality:</h3>

      <p>
        These cookies enable the Website to provide enhanced functionality and
        personalization. They may be set by us or by third party providers whose
        services we have added to our pages. For example, to remember choices
        you make (language or the region you are in), or to recognize the
        platform from which you access the website, and to provide enhanced and
        more personal features. If you do not allow these cookies, then some or
        all of these services may not function properly. These cookies are not
        used to track your browsing on other sites.
      </p>

      <h3>Advertising:</h3>

      <p>
        Advertising cookies are used to collect information about the browsing
        habits associated with your device and are used to make advertising more
        relevant to you and your interests. These cookies may be set through our
        site by our advertising partners. They may be used by those companies to
        build a profile of your interests and show you relevant adverts on other
        sites. They do not store directly personal information but are based on
        uniquely identifying your browser and internet device. If you do not
        allow these cookies, you will experience less targeted advertising.
      </p>

      <p>
        To provide full transparency, the table below lists all cookies used on
        this website, along with their purpose, provider, type, and expiration
        period.
      </p>

      <h3>Necessary Cookies</h3>
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th>Cookie Name</th>
              <th>Provider</th>
              <th>Purpose</th>
              <th>Type</th>
              <th>Expiration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>cookie_consent</td>
              <td>marigrp.com</td>
              <td>
                Remembers the user’s cookie preference settings so the website
                knows which cookies to enable or disable.
              </td>
              <td>First-party, Necessary</td>
              <td>1 year</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3>Analytics Cookies</h3>
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th>Cookie Name</th>
              <th>Provider</th>
              <th>Purpose</th>
              <th>Type</th>
              <th>Expiration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>_ga</td>
              <td>Google</td>
              <td>
                Used to distinguish unique visitors and collect statistical data
                on website usage.
              </td>
              <td>First-party, Analytics</td>
              <td>2 years</td>
            </tr>
            <tr>
              <td>_ga_NEHRMBYF7D</td>
              <td>Google</td>
              <td>
                Used by Google Analytics 4 to maintain session state and track
                user interactions.
              </td>
              <td>First-party, Analytics</td>
              <td>2 years</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2>Consent and Choice</h2>

      <p>
        The following are examples of how you can manage or delete many of the
        cookies that are not strictly necessary.
      </p>

      <h3>Cookie Preference Manager:</h3>

      <p>
        The Cookie Preference Manager can be accessed by clicking on Cookie
        Settings in the cookie banner when you first visit the website, or by
        clicking on the Cookie Settings link in the footer of the website, if
        available. You may choose to allow cookies with your affirmative
        consent, or block cookies that are not strictly necessary.
      </p>

      <h3>Industry opt-out sites:</h3>

      <p>
        You may also opt-out of many cookies served for advertising purposes by
        visiting either:
        <a href="http://www.aboutads.info/choices/" target="_blank"
          >http://www.aboutads.info/choices/</a
        >
        or
        <a href="http://www.networkadvertising.org/choices/" target="_blank"
          >http://www.networkadvertising.org/choices/</a
        >.
      </p>

      <h3>Browser settings:</h3>

      <p>
        Many web browsers accept cookies by default. If you prefer, you can
        usually change your browser's settings to reject and/or to remove many
        cookies. As the precise means by which you may do this will vary from
        browser to browser, please visit your browser's help menu for more
        information.
      </p>

      <p>
        If you choose one of these options, your choices will apply only to the
        specific browser and device from which you opt out and will not affect
        activities or targeted advertising on other browsers or different
        devices.
      </p>

      <p>
        Please be aware that blocking certain cookies may impact the
        functionality and availability of certain areas of the website. Since
        your cookie opt-out preferences are also stored in a cookie in your
        website browser, please also note that if you delete all cookies, use a
        different browser, or buy a new computer, you will need to renew your
        opt-out choices.
      </p>

      <p>
        To opt out of Google Analytics, visit
        <a href="https://tools.google.com/dlpage/gaoptout" target="_blank"
          >https://tools.google.com/dlpage/gaoptout</a
        >.
      </p>

      <h2>Changes to our Cookie Policy</h2>

      <p>
        This Cookie Policy may be updated from time to time. If we change
        anything important about this Cookie Policy, we will notify you through
        a pop-up on the website for a reasonable length of time following the
        change. You may review the Cookie Policy by visiting the website and
        clicking on the "Cookie Policy" link.
      </p>

      <p>
        If you have questions about our Cookie Policy, please contact us at
        <a href="mailto:contactus@marigrp.com">contactus@marigrp.com</a>.
      </p>
    </div>
  </div>
</section>
